let urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('compare')) {
    document.querySelector('.plan-details-section .dialog').classList.add('visible');
    document.querySelector('body').style.overflow = 'hidden';
}

[].forEach.call(document.querySelectorAll('[data-js="compare-all-features"]'), (link) => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.plan-details-section .dialog').classList.add('visible');
        document.querySelector('body').style.overflow = 'hidden';
        urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('compare')) {
            urlParams.set('compare','');
            let newParams = '?' + urlParams.toString().replace('compare=', 'compare');
            history.replaceState(undefined, undefined, window.location.pathname + newParams + window.location.hash);
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'GAEvent',
            eventCategory: 'Pricing',
            eventAction: 'Compare All Features Click',
            eventLabel: link.dataset.datalayer,
        });
    });
});

[document.querySelector('.plan-details-section .dialog'), document.querySelector('.plan-details-section .dialog .close')].forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.plan-details-section .dialog').focus();
        document.querySelector('.plan-details-section .dialog').classList.remove('visible');
        document.querySelector('body').style.overflow = '';
        urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('compare')) {
            urlParams.delete('compare');
            let newParams = (urlParams.toString() !== '' ? '?' + urlParams.toString() : '');
            history.replaceState(undefined, undefined, window.location.pathname + newParams + window.location.hash);
        }
    });
});
document.querySelector('.plan-details-section .dialog .container').addEventListener('click', (e) => {
    e.stopPropagation();
});

const allRows = [...document.querySelectorAll('.plan-details-section tbody tr')];
allRows.forEach((row) => {
    row.dataset.originalfeaturename = row.querySelector('th span').innerText;
});

let activeIndex = 0;
document.querySelector('[data-js="table-filter"]').addEventListener('keyup', (e) => {
    allRows.forEach((row) => {
        row.classList.remove('selected');
        row.classList.remove('focused');
        row.querySelector('th span').innerText = row.dataset.originalfeaturename;
    });
    const selectedRows = allRows.filter((row) => {
        const ret = row.querySelector('th span').innerText.toLowerCase().includes(e.target.value.toLowerCase());
        return ret;
    });
    selectedRows.forEach((row) => {
        const originalValue = row.dataset.originalfeaturename;
        const startIndex = row.dataset.originalfeaturename.toLowerCase().indexOf(e.target.value.toLowerCase());
        const endIndex = startIndex + e.target.value.length;
        row.querySelector('th span').innerHTML = `${row.dataset.originalfeaturename.slice(0, startIndex)}<mark>${row.dataset.originalfeaturename.slice(startIndex, endIndex)}</mark>${row.dataset.originalfeaturename.slice(endIndex)}`;
        row.classList.add('selected');
    });
    if (selectedRows[0]) {
        selectedRows[0].scrollIntoView({ behavior: "smooth", block: "center" });
        selectedRows[0].classList.add('focused');
    }

    if (e.code === 'Enter') {
        if (!selectedRows[activeIndex]) {
            activeIndex = 0;
        }
        if (selectedRows[activeIndex]) {
            selectedRows[activeIndex].scrollIntoView({ behavior: "smooth", block: "center" });
            selectedRows[activeIndex].classList.add('focused');
            activeIndex += 1;
        }
    } else {
        activeIndex = 0;
    }
});
document.querySelector('[data-js="table-filter"]').addEventListener('submit', (e) => e.preventDefault());

let sentinelTimeout;
const intersectionObserver = new IntersectionObserver(() => {
    clearTimeout(sentinelTimeout);
    sentinelTimeout = setTimeout(() => {
        document.querySelector('.plan-details-section thead td').classList.toggle('shadow-visible', document.querySelector('.plan-details-section thead').getBoundingClientRect().top <= 60);
    }, 100);
});

intersectionObserver.observe(document.querySelector('#shadow-sentinel'));
